import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Compass,
  CalendarDays,
  Shield,
  Award,
  Users,
  ChevronRight,
  businessNauticalOptions,
  Briefcase,
  ArrowRight,
  CheckCircle2,
  MapPinned , HeartHandshake, ShipWheel
} from "lucide-react";
import { Trophy, PartyPopper, Sparkles, MapPin, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";

const corporatePartiesFaq = [
  {
    question: "What is a corporate party on a yacht in Mumbai?",
    answer:
      "A corporate party on a yacht in Mumbai is a private company celebration on the water designed for employee engagement, recognition, milestones or festive gatherings."
  },
  {
    question: "Is a yacht a good venue for an awards ceremony?",
    answer:
      "Yes. A yacht offers a more premium and memorable setting for awards ceremonies, recognition events and company milestones."
  },
  {
    question: "What types of companies book yacht celebrations?",
    answer:
      "Startups, SMEs, large corporates, sales teams, leadership teams and businesses planning recognition or festive events can all use this format."
  },
  {
    question: "What can happen during a corporate party or awards ceremony?",
    answer:
      "Companies often use the format for awards presentations, team celebrations, recognition moments, networking, festive gatherings and premium hosted events."
  },
  {
    question: "How is Indiaboats different for corporate celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps companies create polished, memorable and professionally managed corporate events."
  },
  {
    question: "Is this better than a hotel or banquet hall?",
    answer:
      "For many companies, yes. A yacht creates a more distinctive and memorable setting with stronger guest impression and better recall value."
  },
  {
    question: "Can this be used for employee recognition and reward events?",
    answer:
      "Yes. Yacht-based celebrations are especially strong for employee recognition, team milestones and reward experiences."
  },
  {
    question: "How do I enquire about a corporate party or awards ceremony in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, guest count and event objective."
  }
];

const CorporateParties = () => {
  const highlights = [
    {
      text: "Premium corporate sailing regatta experiences in Mumbai",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M22 3c-1.1 0-2 1.2-2 2.5V17c0 .8-.4 1.5-1 2H5c-.6-.5-1-1.2-1-2V5.5C4 4.2 3.1 3 2 3" />
          <path d="M4 17a4 4 0 0 1 8 0v2" />
          <path d="M12 17a4 4 0 0 1 8 0v2" />
        </svg>
      )
    },
    {
      text: "Strong fit for team building and leadership development",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      text: "More engaging than routine corporate outings",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      )
    },
    {
      text: "Scenic and memorable on-water environment",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M2 10c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
          <path d="M2 17c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
        </svg>
      )
    },
    {
      text: "Better team participation and recall value",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      )
    },
    {
      text: "Experience-led planning and premium execution",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      )
    }
  ];

   const businessNauticalOptions = [
    {
      type: "teambuilding",
      badge: "RELATIONSHIP BUILDING",
      title: "Corporate Party or Awards",
      objective: "Client hosting, executive networking, premium hospitality, and business relationship-building",
      desc: "If your main objective is celebration, recognition and internal engagement, then a Corporate Party or Awards Ceremony is usually the best fit.",
      linkText: "Book Now",
      linkUrl: "#corporate-networking",
      icon: <Briefcase size={24} />
    },
    {
      type: "teambuilding",
      badge: "ACTIVE COLLABORATION",
      title: "Corporate Sailing Regattas",
      objective: "Team building, collaboration, leadership development, and active participation",
      desc: "If your main objective is team building and active participation, a Corporate Sailing Regatta is more suitable.",
      linkText: "Book Now",
      linkUrl: "#corporate-regattas",
      icon: <Compass size={24} />
    },
    {
      type: "teambuilding",
      badge: "Networking",
      title: "Corporate Events & Networking",
      objective: "Team building, collaboration, leadership development, and active participation",
      desc: "If your main objective is client hosting and premium relationship-building, a Corporate Events & Networking format is usually the better option.",
      linkText: "Book Now",
      linkUrl: "#corporate-regattas",
      icon: <Users size={24} />
    }
  ];
  
   const benefitsList = [
  "Annual company parties",
  "Awards ceremonies",
  "Employee recognition events",
  "Sales incentive celebrations",
  "Festive corporate gatherings",
  "Team milestone events",
  "Leadership celebration evenings",
  "Reward and recognition experiences"
];

 const outcomes = [
  {
    text: "Awards on Water",
    description:
      "Host an awards ceremony on a yacht and celebrate achievements in a prestigious waterfront setting.",
    icon: <Award size={20} />,
  },
  {
    text: "Annual Milestones",
    description:
      "Celebrate annual milestones with your team in a memorable and exclusive yacht experience.",
    icon: <CalendarDays size={20} />,
  },
  {
    text: "Employee Recognition",
    description:
      "Recognise top performers in a premium setting that makes every achievement feel truly special.",
    icon: <Trophy size={20} />,
  },
  {
    text: "Festive Celebrations",
    description:
      "Create a festive company party on the water with a relaxed atmosphere and stunning views.",
    icon: <PartyPopper size={20} />,
  },
  {
    text: "Networking Experience",
    description:
      "Enjoy networking and meaningful team interaction onboard in a private and premium environment.",
    icon: <Users size={20} />,
  },
  {
    text: "Scenic Cruising",
    description:
      "Combine your corporate celebration with a scenic yacht cruise for a truly unique experience.",
    icon: <ShipWheel size={20} />,
  },
  {
    text: "Employee Engagement",
    description:
      "Create memorable employee engagement moments that strengthen team relationships beyond the workplace.",
    icon: <HeartHandshake size={20} />,
  },
  {
    text: "Special Events",
    description:
      "Host a premium year-end celebration or special occasion event that leaves a lasting impression.",
    icon: <Sparkles size={20} />,
  },
];

  return (
    <div>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="csrh-master-wrapper">
        
        <div className="csrh-absolute-bg" style={{backgroundImage:'url(/assets/img/cparty2.png)'}}></div>
        <div className="csrh-absolute-overlay"></div>

        {/* Relative Content Area */}
        <div className="csrh-content-container">
          {/* Centered Editorial Header Section */}
          <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              A More Memorable Way to  <br />
              <span className="csrh-title-italic">
               Celebrate Company Milestones
              </span>
            </h1>
           
          </div>

          {/* Narrative Copy Layout Grid */}
          <div className="csrh-narrative-grid">
            {/* Left Narrative Column */}
            <div className="csrh-narrative-column csrh-border-right">
              {/* Card block for Paragraph 1 */}
              <div className="csrh-text-card">
                {/* <div className="csrh-card-icon-box">
                  <Users size={20} />
                </div> */}
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle">
                    Active Collaboration Format
                  </h3> */}
                  <p className="csrh-p-lead">
                   A corporate party or awards ceremony on a yacht in Mumbai offers a more distinctive and memorable alternative to standard banquet venues, hotel halls and restaurant gatherings. The setting feels more premium, the event feels more special and the overall experience leaves a stronger impression on employees, teams and guests.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 2 */}
              {/* <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Wind size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle">
                    Live Decision-Making Environment
                  </h3>
                  <p className="csrh-p-body">
                    In simple terms, it is a corporate event built around
                    sailing. Instead of sitting through a routine offsite or
                    attending a passive team outing, participants work together
                    in a live environment where communication, coordination and
                    decision-making matter. The experience is designed to be
                    engaging, memorable and highly interactive.
                  </p>
                </div>
              </div> */}
            </div>

            {/* Right Narrative Column */}
            <div className="csrh-narrative-column">
              {/* Card block for Paragraph 3 */}
              <div className="csrh-text-card csrh-premium-highlight">
                {/* <div className="csrh-card-icon-box csrh-accent-icon">
                  <Anchor size={20} />
                </div> */}
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle csrh-accent-text">
                    Why It Matters in Mumbai
                  </h3> */}
                  <p className="csrh-p-body">
                    Whether you are celebrating annual targets, recognising top performers, hosting a festive company event or planning an internal milestone celebration, a yacht creates an atmosphere that feels elevated and rewarding from the moment guests arrive.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 4 */}
              <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Award size={20} />
                </div>
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle">
                    The Indiaboats Operational Guarantee
                  </h3> */}
                  <p className="csrh-p-body">
                   With Indiaboats, corporate celebrations on the water feel polished, scenic and professionally managed.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Footer Bar */}
          <div className="csrh-action-footer">
            <div className="csrh-trust-indicators">
              <div className="csrh-trust-pill">
                <Shield size={14} className="csrh-pill-icon" />
                <span>National Safety Protocols</span>
              </div>
              <div className="csrh-trust-pill">
                <Compass size={14} className="csrh-spin-slow csrh-pill-icon" />
                <span>Expert Skipper Command</span>
              </div>
            </div>

            <button className="csrh-premium-btn">
              <span>Enquire About Corporate Party Yachts</span>
              <div className="csrh-btn-arrow-wrap">
                <ChevronRight size={14} />
              </div>
            </button>
          </div>
        </div>
      </section>

      <section className="csrw-master-section" id="csrw_master">
        <div className="csrw-container">
          {}
          {/* Editorial Section Header */}
          <div className="csrw-header-block">
            <h2 className="csrw-section-title">
              Why a Yacht {" "}
              <span className="csrw-serif-italic">
                Is a Stronger Setting for Corporate Celebrations
              </span>
            </h2>
           
          </div>

          {}
          {/* Chronological Process Grid */}
          <div className="csrw-process-flow" id="cp-process-flow">
            {/* Step 1 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                  <MapPinned size={20} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Ideal Venue</h3>
                <p className="csrw-card-text">
                 A yacht makes a corporate celebration feel more exclusive, more impressive and more enjoyable than a routine land-based venue. It gives your team a private event space on the water with skyline views, sea breeze and a stronger sense of occasion.
                </p>
              </div>
            </div>

            {/* Step 2 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                <Sparkles size={20} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Memorable Events</h3>
                <p className="csrw-card-text">
                  For awards ceremonies, the setting adds prestige and recall value. For company parties, it creates a more relaxed and premium atmosphere. For reward events, it helps the experience feel genuinely special rather than routine.
                </p>
              </div>
            </div>

            
          </div>

          {/* Value Takeaway Banner */}
          <div className="csrw-takeaway-banner">
            <div className="csrw-banner-inner" id="cp-banner-inner">
              <div className="csrw-banner-icon-area">
                <CheckCircle2 size={32} className="csrw-check-icon" />
              </div>
              <div className="csrw-banner-content">
               
                <p className="csrw-banner-text">
                 Recognition feels better when the setting feels special.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="csrb-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Ideal for Corporate Parties and  <span className="csrb-serif-italic">
                Awards Events
              </span>
            </h2>
            <div className="csrb-title-divider"></div>
            <p className="csrb-lead-paragraph">
              This format works especially well for companies that want to celebrate, recognise and reward their teams in a more memorable setting.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

       <section className="rse-root-wrapper">
        <div className="rse-editorial-container">
          {/* Section Header */}
          <div className="rse-header-block">
            <h2 className="rse-section-title">
              What You Can Do During a Corporate Party or {" "}
              <span className="rse-serif-italic">Awards Ceremony</span>
            </h2>
            <div className="rse-header-divider"></div>
            <p className="rse-section-paragraph">
             A yacht-based corporate event can be styled as a lively celebration, a refined awards evening or a premium hosted company gathering depending on the tone you want to create.
            </p>
          </div>

          {/* Minimalist Editorial List Layout (Replaces the Bento Grid) */}
          <div className="rse-outcomes-list">
            {outcomes.map((item, index) => (
              <div key={index} className="rse-outcome-list-item">
                <div className="rse-item-main-content">
                  {/* Clean, minimalist circular icon container */}
                  <div className="rse-icon-circle">{item.icon}</div>

                  {/* Vertical text stack with clean hierarchy */}
                  <div className="rse-text-stack">
                    <h3 className="rse-item-title">{item.text}</h3>
                    <p className="rse-item-desc">{item.description}</p>
                  </div>
                </div>

                {/* Dynamic decorative element that shifts on row hover */}
                {/* <div className="rse-item-action">
                  <span className="rse-action-badge">Development Goal</span>
                  <ArrowRight size={16} className="rse-arrow-icon" />
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

        <section className="wefl-pre-root-wrapper">
        <div className="wefl-pre-editorial-container">
          <div className="wefl-pre-split-layout">
            {/* Left Column: Rich Editorial Copy */}
            <div className="wefl-pre-narrative-column">
              <div className="wefl-pre-header-block">
                <h2 className="wefl-pre-section-title">
                  What the Experience{" "}
                  <span className="wefl-pre-serif-italic">Feels Like</span>
                </h2>
                <div className="wefl-pre-header-divider"></div>
              </div>

              <div className="wefl-pre-text-block wefl-pre-highlight-block">
                <div className="wefl-pre-accent-stripe"></div>
                <p className="wefl-pre-paragraph-lead">
                 A corporate party or awards ceremony on a yacht feels more exclusive and more rewarding than a standard event venue. The private setting, open water and premium atmosphere make the event feel like a true experience rather than just another corporate function.
                </p>
                
              </div>

              <div className="wefl-pre-text-block">
                <p className="wefl-pre-paragraph">
                  For employees, it feels more exciting and memorable. For leadership teams, it feels more polished and brand-positive. For the company overall, it creates stronger recall and better guest experience.
                </p>
              </div>

              

              {/* Subtle Features List below text for high-end feel */}
              {/* <div className="wefl-pre-features-list">
                <div className="wefl-pre-feature-item">
                  <Wind size={18} className="wefl-pre-feature-icon" />
                  <span>Energising Setting</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Compass size={18} className="wefl-pre-feature-icon" />
                  <span>Active Presence</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Waves size={18} className="wefl-pre-feature-icon" />
                  <span>Premium Marine Edge</span>
                </div>
              </div> */}
            </div>

            {}
            <div className="wefl-pre-image-column">
              <div className="wefl-pre-image-wrapper">
                {/* Outer decorative border frame for editorial look */}
                {/* <div className="wefl-pre-image-accent-border"></div> */}

                {/* High-quality corporate/team sailing image */}
                <img
                  className="wefl-pre-main-image"
                  src="assets/img/cparty1.png"
                  alt="Corporate team sailing on a premium yacht"
                />

                {/* Elegant Floating Stat Badge overlay on image */}
                <div className="wefl-pre-floating-badge">
                  <span className="wefl-pre-badge-title">Mumbai Harbour</span>
                  <span className="wefl-pre-badge-subtitle">
                    The Premium Alternative
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wpc-section-wrapper">
      {}
      <div className="wpc-container">
        <div className="wpc-grid">
          
          {/* Left Editorial Column: Copy Narratives */}
          <div className="wpc-content-col">
           <div className="wefl-pre-header-block">
                <h2 className="wefl-pre-section-title">
                  Why Plan Corporate Parties & {" "}
                  <span className="wefl-pre-serif-italic">Awards Events with Indiaboats</span>
                </h2>
                <div className="wefl-pre-header-divider"></div>
              </div>
            
            <p className="wpc-paragraph">
              Indiaboats offers premium yacht experiences in Mumbai and helps companies create corporate celebrations that feel smooth, memorable and professionally hosted. We understand that these events are not only about celebration, but also about employee appreciation, company culture and brand impression.
            </p>
            
            <p className="wpc-paragraph">
              From helping you choose the right yacht format to guiding you on the right event style for your group, Indiaboats makes it easier to plan a corporate event that feels elevated from start to finish.
            </p>
          </div>

          {}
          {/* Right Column: Custom Interactive Highlights */}
          <div className="wpc-highlights-col">
            
            {/* Highlight 1 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M2 21h20M19.307 10.612a4 4 0 0 1-5.619 0L12 8.922l-1.688 1.69a4 4 0 0 1-5.619 0a4 4 0 0 1 0-5.62l1.688-1.69L12 1.613l5.619 5.62l1.688 1.69a4 4 0 0 1 0 5.619z" />
                  <path d="M12 8.922v12M8 15h8" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Premium corporate party experiences in Mumbai</h3>
              </div>
            </div>

            {/* Highlight 2 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <circle cx="12" cy="8" r="7" />
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Yacht awards ceremony format</h3>
              </div>
            </div>

            {}
            {/* Highlight 3 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Strong fit for employee recognition and celebrations</h3>
              </div>
            </div>

            {/* Highlight 4 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v8M8 12h8" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">More memorable than standard venues</h3>
              </div>
            </div>

            {}
            {/* Highlight 5 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M12 2a10 10 0 0 0-10 10c0 5.523 4.477 10 10 10s10-4.477 10-10A10 10 0 0 0 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Scenic and exclusive event setting</h3>
              </div>
            </div>

            {/* Highlight 6 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Experience-led planning and premium execution</h3>
              </div>
            </div>

            {/* Highlight 7 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Better hospitality and stronger event recall</h3>
              </div>
            </div>

          </div>

        </div>
      </div>
      </section>

      <section className="cxe-main-section">
      <div className="cxe-container">
        
       
        <div className="cxe-header-block">
          <div className="cxe-tag-row">
            <Shield size={14} className="cxe-shield-icon" />
            <span className="cxe-pre-title">Decision Framework</span>
          </div>
          <h2 className="cxe-section-title">
            Which Corporate Experience <span className="cxe-light-text">Is Right for Your Business</span>
          </h2>
          <p className="cxe-section-subtitle">
            Align your strategic organizational outcomes with our curated world-class marine formats.
          </p>
        </div>

        
        <div className="cxe-decision-grid" id="cp_decision_grid">
          {businessNauticalOptions.map((option, index) => {
            const isNetworking = option.type === "networking";
            return (
              <div 
                key={index} 
                className={`cxe-decision-card ${isNetworking ? 'cxe-card-dark' : 'cxe-card-light'}`}
              >
                <div className="cxe-card-accent-line"></div>
                
                <div className="cxe-card-header">
                  <div className="cxe-icon-box">
                    {option.icon}
                  </div>
                  <span className="cxe-card-badge">{option.badge}</span>
                </div>

                <div className="cxe-card-body">
                  <h3 className="cxe-card-title">{option.title}</h3>
                  <p className="cxe-card-desc">{option.desc}</p>
                </div>

                <div className="cxe-card-footer">
                  <a href={option.linkUrl} className="cxe-anchor-link">
                    <span>{option.linkText}</span>
                    <div className="cxe-arrow-wrapper">
                      <ArrowRight size={16} />
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>

      </div>
      </section>

      <section className="wcre-brutalist-wrapper">
        <div className="wcre-editorial-container">
          {}
          {/* Header block with solid bottom grid line */}
          <div className="wcre-main-header-block">
            <h2 className="wcre-giant-title">
              Why Companies Choose Yacht Celebrations Over Standard Venues
            </h2>
          </div>

          {}
          {/* Row 1: Left Image, Right text block */}
          <div className="wcre-grid-row wcre-row-one">
            {/* Row 1 Left: High-performance Yacht Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/cparty3.png"
                  alt="Corporate teams executing maneuvers in active regatta"
                  className="wcre-grid-img"
                />
              </div>
            </div>

            {/* Row 1 Right: Deep prose on active collaboration */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Stronger Recall Value</h3>
                <p className="wcre-cell-paragraph">
                  Many companies choose yacht-based celebrations because they create stronger recall value, better employee experience and a more premium overall setting than standard event spaces. 
                </p>
                
              </div>
            </div>
          </div>

          {}
          {/* Row 2: Left text block, Right Image */}
          <div className="wcre-grid-row wcre-row-two">
            {/* Row 2 Left: Narrative on De-Siloing & Trust */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Meaningful Adventure</h3>
                <p className="wcre-cell-paragraph">
                 A yacht helps turn a company celebration into something people genuinely remember, which makes it especially effective for recognition, milestones and internal culture moments.
                </p>

                
              </div>
            </div>

            {/* Row 2 Right: Second Complementary Yachting Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/cparty2.png"
                  alt="Yachts competing in perfect coordination on Mumbai waters"
                  className="wcre-grid-img"
                />
              </div>
            </div>
          </div>

          {}
          {/* Editorial trust footer bar structured like the bottom lines of the design layout */}
          <div className="wcre-grid-footer">
            <div className="wcre-footer-pill">
              <Shield size={14} />
              <span>Led by Champion Racing Skippers</span>
            </div>
            <div className="wcre-footer-pill">
              <Award size={14} />
              <span>Premium Experience Guarantee</span>
            </div>
          </div>
        </div>
      </section>

     

    

      

     

      

    


       <section className="wtei-section" id="corporateParties_wtei">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          {/* Left Column: Title and Narrative Copy */}
          <div className="wtei-col-left">
            <h2 className="wtei-title">
              What to Expect with Indiaboats
            </h2>
            <p className="wtei-paragraph">
              When you plan a corporate party or awards ceremony with Indiaboats, the experience is designed to feel premium, smooth and easy to organise. We help companies understand which format suits their guest profile, event objective and celebration style so the event feels both polished and enjoyable.
            </p>
            
          </div>

          { }
          {/* Right Column: Inclusions Style List */}
          <div className="wtei-col-right">
            <ul className="wtei-list">
              
              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Premium yacht event experience in Mumbai</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Guidance based on event objective and group style</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Strong fit for celebrations and recognition</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Scenic and memorable on-water setting</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Better experience than routine venues</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Supportive and experience-led planning</span>
              </li>

            </ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Coordination and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
           At Indiaboats, safety is central to every corporate event. We place strong emphasis on trained crew, responsible operations, guest comfort and professional coordination so your celebration feels smooth, enjoyable and well managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  pageKey="corporate-party-awards-yacht-mumbai"
  title="Frequently Asked Questions About Corporate Events in Mumbai"
  faqData={corporatePartiesFaq}
/>
     
             <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Business Event</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Company Name</label>
      <input type="text" placeholder="Enter company name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Event Objective</label>
      <select>
        <option>Select event objective</option>
        <option>Client Appreciation</option>
        <option>Networking Evening</option>
        <option>Leadership Gathering</option>
        <option>Partner/Investor Meet</option>
        <option>Reward & Recognition</option>
        <option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

        
      <Footer />
    </div>
  );
};

export default CorporateParties;
